import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { shortListCandidates } from "@/reducers/clientscandidates";
import { toastMessageText } from "@/utilities/CommonText";
import { showCommonToast } from "@/utilities/utils";

const MarkAsPreferredButton = ({
  selectedCandidate = [],
  loading = false,
  setLoading,
  page,
  isSelectedAll = false,
  ignoreIds = "",
  deSelectAllCandidate,
  callback,
  type = "",
}) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  const handleButtonClick = useCallback(() => {
    if (selectedCandidate.some((candidate) => candidate !== "")) {
      dispatch(deSelectAllCandidate());
      dispatch(
        shortListCandidates({
          candidate_ids: selectedCandidate,
          loading,
          page,
          isSelectedAll,
          ignoreIds,
          setLoading,
          callback,
        }),
      );
    } else {
      const message =
        type === "invited"
          ? toastMessageText.selectregisteredCandidate
          : toastMessageText.noCandidateSelected;
      showCommonToast(message, { id: "no-candidate-selected" });
    }
  }, [
    selectedCandidate,
    dispatch,
    deSelectAllCandidate,
    setLoading,
    page,
    isSelectedAll,
    ignoreIds,
    callback,
    type,
    loading,
  ]);

  // if (!clientUserAllPermissions || !clientUserAllPermissions.is_allow_to_marking_candidate) return null;

  return null;
};

export default MarkAsPreferredButton;
